interface ActionTypes {
  ACCEPT_EULA_START: string;
  ACCEPT_EULA_SUCCESS: string;
  ACCEPT_EULA_FAILURE: string;
  GET_EULA_START: string;
  GET_EULA_SUCCESS: string;
  GET_EULA_FAILURE: string;
}

export const EulaActionTypes: ActionTypes = {
  ACCEPT_EULA_START: '@@ACCEPT_EULA_START',
  ACCEPT_EULA_SUCCESS: '@@ACCEPT_EULA_SUCCESS',
  ACCEPT_EULA_FAILURE: '@@ACCEPT_EULA_FAILURE',
  GET_EULA_START: '@@GET_EULA_START',
  GET_EULA_SUCCESS: '@@GET_EULA_SUCCESS',
  GET_EULA_FAILURE: '@@GET_EULA_FAILURE'
};

export interface EulaState {
  eulaContent: string;
  process: 'initial' | 'loading' | 'accepting' | 'loaded' | 'success' | 'fail';
  error?: string;
}
